export const setFavIcon = (name:string) =>{
	const el = (document.querySelector("link[rel*='icon']") || document.createElement("link")) as HTMLLinkElement
	el.type = "image/x-icon";
	el.rel = "shortcut icon";
	el.href = `/favicon/${name}.ico`;
	document.getElementsByTagName("head")[0].appendChild(el);
};